import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'
const InteractorPaymentCreate = () => {
  const { t } = useTranslation()

  const paymentCreate = useCallback(
    (payload) => {
      ApiService.jsonRequest('/fund-payment/create', payload, (response) => {
        if (response.status_code === 200 && response.messages === 'request_success') {
          showAlert({
            icon: 'success',
            message: t('response_message.payment_success'),
            timer: 2000,
            redirect: response?.data?.payment_invoice_url ?? '/bill',
          })
        } else {
          if (
            response.messages === 'data_already_exists' &&
            response?.data?.payment_invoice_url !== '' &&
            response?.data?.status === 'PENDING'
          ) {
            showAlert({
              icon: 'success',
              message: t('response_message.payment_success'),
              timer: 2000,
              redirect: response?.data?.payment_invoice_url ?? '/bill',
            })
          } else {
            showAlert({
              icon: 'warning',
              message: t('response_message.payment_failed'),
              timer: 2000,
              redirect: '/bill',
            })
          }
        }
      })
    },
    [t],
  )
  return { paymentCreate }
}

export default InteractorPaymentCreate
